import {api} from "../http/apiClient"

const ApiCMS = () => {
  const getAllPills = (page, page_size) => {
    return api.get("/cms/", {
      params: {
        page: page,
        page_size: page_size,
      },
    })
  }

  const getPillById = (id, cnpj) => {
    return api.get(`/cms/${id}`, {
      params: {
        cnpj,
      },
    })
  }

  return { getAllPills, getPillById }
}

export default ApiCMS
